<template>
  <v-card>
    <v-toolbar
      class="white--text"
      color="indigo"
      style="position: sticky; top: 0px; z-index: 1"
      dense
    >
      <v-toolbar-title>Impostazione Turno </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickSave" small v-bind="attrs" v-on="on">
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="$router.push('/home/production')"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>

    <v-progress-linear indeterminate color="cyan" v-if="loading" id="progress">
    </v-progress-linear>

    <v-card-text>
      <v-col>
        <v-row>
          <h3 class="mt-5">
            {{ "Inserisci il turno in cui lavori oggi " + dateStr }}
          </h3>
        </v-row>
      </v-col>
      <v-row align="center" class="mt-5 pr-5" justify="center">
        <v-col>
          <h3>Turno</h3>
        </v-col>
        <v-select
          :items="tipiTurno"
          item-text="cod_turno"
          item-value="id_turno"
          v-model="turnoSelezionato"
        >
          <template #item="{ item }">
            <div style="text-align: center; width: 100%">
              <span style="font-size: 20px; font-weight: bold">
                {{ item.cod_turno }}
              </span>
            </div>
          </template>
        </v-select>
      </v-row>
    </v-card-text>

    <!-- Dialog di conferma eliminazione dei partner -->
    <v-dialog v-model="dialog_conferma_turno" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Hai selezionato il turno
            {{
              tipiTurno.filter((e) => e.id_turno == turnoSelezionato).length > 0
                ? tipiTurno.filter((e) => e.id_turno == turnoSelezionato)[0]
                    .cod_turno
                : ""
            }}
            tra le ore<br />
            {{
              tipiTurno.filter((e) => e.id_turno == turnoSelezionato).length > 0
                ? tipiTurno.filter((e) => e.id_turno == turnoSelezionato)[0]
                    .ora_inizio
                : ""
            }}
            e
            {{
              tipiTurno.filter((e) => e.id_turno == turnoSelezionato).length > 0
                ? tipiTurno.filter((e) => e.id_turno == turnoSelezionato)[0]
                    .ora_fine
                : ""
            }}.<br />
            Sei veramente sicuro di voler avviare il turno
            {{
              tipiTurno.filter((e) => e.id_turno == turnoSelezionato).length > 0
                ? tipiTurno.filter((e) => e.id_turno == turnoSelezionato)[0]
                    .cod_turno
                : ""
            }}?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_turno = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="save" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "DichiarazioneTurni",
  components: { SnackbarQV },
  data() {
    return {
      // Variabili di supporto
      dateStr: "",
      turnoSelezionato: "",

      // Modal
      dialog_conferma_turno: false,
      loading: false,

      // Array
      tipiTurno: [],
    };
  },
  mounted() {
    this.inizializza();
  },
  methods: {
    inizializza() {
      this.loading = true;

      this.dateStr = moment().format("DD/MM/YYYY");

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getturnocodici",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.tipiTurno = res.data.result.turno_codici;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        });

      this.loading = false;
    },
    checkOrario() {
      let turno_tmp = null;
      this.tipiTurno.forEach((t) => {
        if (t.id_turno == this.turnoSelezionato) {
          turno_tmp = JSON.parse(JSON.stringify(t));
        }
      });

      let data = moment().format("YYYY-MM-DD");

      // Registro il momento attuale.
      let adesso_tmp = moment();

      // Registro l'ora inizio
      let inizio_tmp = moment(
        `${data} ${this.safeFormat(
          turno_tmp.ora_inizio.split(":")[0]
        )}:${this.safeFormat(
          turno_tmp.ora_inizio.split(":")[1]
        )}:${this.safeFormat(turno_tmp.ora_inizio.split(":")[2])}`
      );

      inizio_tmp.subtract(Number(this.safeFormat(turno_tmp.anticipo_inizio_minuti)), "minutes");

      // Registro l'ora fine
      let fine_tmp = moment(
        `${data} ${this.safeFormat(
          turno_tmp.ora_fine.split(":")[0]
        )}:${this.safeFormat(
          turno_tmp.ora_fine.split(":")[1]
        )}:${this.safeFormat(turno_tmp.ora_fine.split(":")[2])}`
      );

      fine_tmp.add(Number(this.safeFormat(turno_tmp.posticipo_fine_minuti)), "minutes");

      /* Controllo che il momento attuale sia
       * compatibile con l'inizio e fine del turno. */
      return adesso_tmp.isBetween(inizio_tmp, fine_tmp, undefined, "[]");
    },
    async clickSave() {
      // Controllo che sia stato selezionato un turno.
      if (this.turnoSelezionato == null || this.turnoSelezionato == "") {
        this.$refs.SnackbarQV.print("orange", "Selezionare un turno.");
        return;
      }

      // Controllo che l'orario sia compatibile.
      let is_orario_conforme = this.checkOrario();

      /* Se l'orario è compatibile salvo
       * altrimenti chiedo conferma. */
      if (is_orario_conforme === true) {
        this.save();
      } else {
        this.dialog_conferma_turno = true;
      }
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    safeFormat(arg) {
      let res = arg;

      if (res == null || res == "") {
        res = "00";
      }

      return res;
    },
    async save() {
      // Chiudo il dialog di conferma in caso sia stato aperto.
      this.dialog_conferma_turno = false;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setturno",
          id_turno: this.turnoSelezionato,
          token: localStorage.user_token,
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          let cod_tmp = "";
          this.tipiTurno.forEach((t) => {
            if (t.id_turno == this.turnoSelezionato) {
              cod_tmp = t.cod_turno;
            }
          });

          this.$emit("click_save", cod_tmp);
        }
      });
    },
  },
};
</script>